import { history } from '@umijs/max';
import { Dropdown, Space, Avatar, Spin } from 'antd';
import {
  LogoutOutlined,
  UserOutlined,
  SettingOutlined,
  CopyOutlined,
} from '@ant-design/icons';
import { clearAuthInfo, showSuccessMessage } from '@/utils/errorHandler';
import type { User } from 'types';
import styles from './AvatarDropdown.less';

interface AvatarDropdownProps {
  children: React.ReactNode;
  currentUser?: User;
}

export default function AvatarDropdown({
  children,
  currentUser,
}: AvatarDropdownProps) {
  const handleLogout = () => {
    // 清除 token
    clearAuthInfo();
    showSuccessMessage('登出成功');

    // 刷新页面以更新 baseURL
    setTimeout(() => {
      window.location.href = '/user/login';
    }, 500);
  };

  const handleProfile = () => {
    history.push('/user/profile');
  };

  const handleSettings = () => {
    history.push('/user/settings');
  };

  const handleCopyUserId = () => {
    if (currentUser?.id) {
      navigator.clipboard.writeText(currentUser.id);
      showSuccessMessage('用户 ID 已复制');
    }
  };

  const items = [
    {
      key: 'info',
      label: (
        <div className={styles.userInfo}>
          <div className={styles.username}>{currentUser?.username}</div>
          <div className={styles.email}>{currentUser?.email}</div>
        </div>
      ),
      disabled: true,
    },
    {
      type: 'divider' as const,
    },
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人资料',
      onClick: handleProfile,
    },
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: '账户设置',
      onClick: handleSettings,
    },
    {
      key: 'copyId',
      icon: <CopyOutlined />,
      label: '复制用户 ID',
      onClick: handleCopyUserId,
    },
    {
      type: 'divider' as const,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '登出',
      onClick: handleLogout,
      danger: true,
    },
  ];

  return (
    <Dropdown menu={{ items }} placement="bottomRight" trigger={['click']}>
      <Space style={{ cursor: 'pointer' }} className={styles.container}>
        <Avatar
          size="large"
          src={currentUser?.profile?.picture}
          icon={<UserOutlined />}
          alt={currentUser?.username}
        />
        <span className={styles.username}>{currentUser?.username || '用户'}</span>
      </Space>
    </Dropdown>
  );
}